// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2cc7c750","666":"13b7d189"}[chunkId] + ".chunk.js";
};